export default function (formatMessage: Function) {
  return {
    channelOptions: [
      {
        value: "GeniusLab",
        label: formatMessage({
          id: "terminate_reason_won_geniuslab",
          defaultMessage: "GeniusLab",
        }),
      },
      {
        value: "OtherKKChannel",
        label: formatMessage({
          id: "terminate_reason_won_other_kerakoll_contact",
          defaultMessage: "Altro contatto Kerakoll",
        }),
      },
      {
        value: "Other",
        label: formatMessage({
          id: "terminate_reason_won_other",
          defaultMessage: "Altro",
        }),
      },
    ],
  };
}
